import { format } from 'date-fns';
import { enUS, es } from 'date-fns/locale';

const YMD_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export function parseYmdLocal(ymd: string): Date | null {
  const match = ymd.trim().match(YMD_PATTERN);
  if (!match) return null;
  const [, y, m, d] = match.map(Number);
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? null : date;
}

function getDateFnsLocale(language: string) {
  return language.startsWith('es') ? es : enUS;
}

/** Fecha de envío (Y-m-d API) → texto legible, p. ej. 25 may 2026 */
export function formatShipDateForDisplay(ymd: string, language: string): string {
  const date = parseYmdLocal(ymd);
  if (!date) return ymd;
  return format(date, 'd MMM yyyy', { locale: getDateFnsLocale(language) });
}

export function formatShipDateRangeForDisplay(
  dateFrom: string,
  dateTo: string,
  language: string,
): { from: string; to: string } {
  return {
    from: formatShipDateForDisplay(dateFrom, language),
    to: formatShipDateForDisplay(dateTo, language),
  };
}
